import { render, staticRenderFns } from "./CaseList.vue?vue&type=template&id=5fa9f292&scoped=true"
import script from "./CaseList.vue?vue&type=script&lang=js"
export * from "./CaseList.vue?vue&type=script&lang=js"
import style0 from "./CaseList.vue?vue&type=style&index=0&id=5fa9f292&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa9f292",
  null
  
)

export default component.exports